module.exports = __webpack_public_path__ + "static/ada4-723daf39796b004acf4cde654589b007.jpg";